/**
 * name: @storyblok/vue
 * (c) 2025
 * description: SDK to integrate Storyblok into your project using Vue.
 * author: Storyblok
 */
import { defineComponent as r, createElementBlock as p, openBlock as a, createElementVNode as n, createTextVNode as c, toDisplayString as d } from "vue";
const m = { class: "fallback-component" }, _ = { class: "component" }, f = /* @__PURE__ */ r({
  __name: "FallbackComponent",
  props: {
    blok: {}
  },
  setup(t) {
    return (e, o) => (a(), p("div", m, [
      n("p", null, [
        o[0] || (o[0] = c(" Component could not be found for blok ")),
        n("span", _, d(e.blok.component), 1),
        o[1] || (o[1] = c("! Is it configured correctly? "))
      ])
    ]));
  }
}), i = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [s, l] of e)
    o[s] = l;
  return o;
}, u = /* @__PURE__ */ i(f, [["__scopeId", "data-v-9abcd1f2"]]);
export {
  u as default
};
